import React, { useEffect, useState, useRef } from "react";
import {
    Button, Tag, notification, Empty, Alert, Tooltip
} from "antd";
import {
    CloseOutlined, UsergroupAddOutlined, HeartOutlined, ArrowUpOutlined, FolderFilled, InfoCircleOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Draggable } from "react-drag-and-drop";
import { FaUsers } from "react-icons/fa";
import { removeDeepDiveItemInGroup, setListOfSubItems, setSubItemsDataPerGroup, setTileSelected, setVisibleInsightsModal } from "../../../../store/components/Reports.slice";
import { fRenderShare, getAllKeywordsInFolder, getCountryCode, getModuleCode, getSelectedAnalysis } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import useShowInsights from "../../../../hooks/useShowInsights"
import CrownSubscription from "../../../ReportBuilder/Insights/CrownSubscription"
import { HiOutlineLightBulb } from "react-icons/hi";
import { folderStyle, formatNumber, isArray, isViewer } from "../../../../utils/MainHelper";
import { setCompareInputTab } from "../../../../store/components/Insights.slice";
import TableProgress from '../../../General/TableProgress'
import ReportsServices from "../../../../services/Reports.services";
import RingProgressSkeleton from "../../../General/skeleton/RingProgressSkeleton"
import GaugeSkeleton from "../../../General/skeleton/GaugeSkeleton"
import TableSkeleton from "../../../General/skeleton/TableSkeleton"
import RenderComponent from "../../../General/RenderComponent"
import RingProgressChart from "../../../Charts/RingProgressChart"
import GaugeChart from "../../../Charts/GaugeChart"
import CustomLayout from "../../../General/CustomLayout/CustomLayout";
import CustomTable from "../../../../customcomponents/customtable/CustomTable";
import TrackFeatureServices from "../../../../services/TrackFeature.services";

import ListOfDontDeepDive from '../../../../config/ListOfDontDeepDive.json'
import { getWhiteLabelDictionary } from "../../../../utils/whitelabel/WhiteLabel.Helper";

const itemCss = {
    padding: 0,
    whiteSpace: "pre-wrap",
    textAlign: "left",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100%"
};

function CategoryDeepDiveContent({
    data = {
        children: []
    },
    subItems = [],
    interestLevel = 0,
    itemStatus = {},
    columns = [],
    loading = true,
    dontDeepDive = false,
    noCheckbox = false,
    fromSelectedTile,
    share
}) {
    const itemRef = useRef();
    const dispatch = useDispatch();
    const [showAlert, setshowAlert] = useState(false);
    const [subItemsIsLoading, setSubItemsIsLoading] = useState(false);
    const {
        setup: {
            marketPackage
        },
        countryNotAvailable
    } = useSelector((state) => state.buildTargets);

    const { tilesSelected } = useSelector((state) => state.reports);
    const { compareInputTab } = useSelector((state) => state.insights);
    const selectedRow = tilesSelected?.[data.key] || [];
    const moduleCode = getModuleCode()
    const onClickItem = (row) => {
        dispatch(setListOfSubItems({
            ...row,
            group: data.group || row.group
        }));
    };
    const isClickable = (row) => {
        if ((countryNotAvailable || isViewer())) return false;
        if (moduleCode === "facebookaudiences") {
            if (!row.tempChildren) return false;
        }

        return true;
    };

    const getIcon = (hasChildren) => {
        const isMediaPlanning = moduleCode.includes("mediaplanning") || moduleCode.includes("b2b");
        if (hasChildren && !isViewer()) {
            if (isMediaPlanning) {
                return <FaUsers style={{ ...folderStyle, marginTop: "3px", color: "" }} />;
            }
            return <FolderFilled style={{ ...folderStyle, marginTop: "3px" }} />;
        }
        return "";
    };
    const savantCode = getCountryCode("savant")
    const analysis = getSelectedAnalysis();

    const { showInsights } = useShowInsights()
    const newColumns = columns.reduce((acc, col) => {
        if (col.key === "insights" && isViewer()) return acc;

        const colObj = {
            ...col,
            dataIndex: col.key
        };
        switch (col.key) {
            case "item": {
                colObj.key = "key"
                colObj.render = (value, row) => {
                    if (dontDeepDive) return value;

                    const hasChildren = row.tempChildren || row.children;

                    let newValue = value.includes(":") ? value.split(":")[1].trim() : value;
                    if (hasChildren) {
                        newValue = value
                    }

                    if (["globalwebindex"].includes(moduleCode) && hasChildren) {
                        const [firstChild] = hasChildren
                        if (!firstChild.tempChildren && !firstChild.children)
                            return value
                    }
                    if (["gdn", "tiktokaudiences", "facebookaudiences", "lineaudience", "yahoodisplay", "globalwebindex"].includes(moduleCode) && !hasChildren) {
                        console.log("No Deepdive")
                        return value
                    }

                    if (row.path) {
                        const newPath = row.path.split("/").map((d) => {
                            if (d.split("~~").length > 1) return d.split("~~")[1]
                            return d
                        }).join("/");

                        if (ListOfDontDeepDive[savantCode]) {
                            if (ListOfDontDeepDive[savantCode].includes(newPath.toLocaleLowerCase())) return value;
                        }
                    }
                    return (
                        <Draggable
                            type="behavior"
                            data={JSON.stringify({ ...row, categoryName: data.discoveredCategory })}
                            onDrag={() => {
                                if (compareInputTab !== "compare") {
                                    dispatch(setCompareInputTab("compare"));
                                }
                            }}
                        >
                            <p
                                onClick={() => {
                                    if (!isClickable(row)) return;
                                    onClickItem(row);
                                }}
                                style={{
                                    ...itemCss,
                                    ...(!isClickable(row) ? {} : {
                                        cursor: "pointer",
                                        color: "#1890ff",
                                        textDecoration: "underline"
                                    })
                                }}
                                className="d-flex"
                            >
                                {getIcon(hasChildren)}
                                <span style={{
                                    whiteSpace: "prewrap",
                                    width: hasChildren ? "calc(100% - 6mm)" : "100%"
                                }}
                                >
                                    {newValue}
                                </span>
                            </p>
                        </Draggable>
                    );
                };
                break;
            }
            case "behaviormatch": {
                colObj.align = "center";
                colObj.render = (value, row) => (
                    <Tag
                        className="fw-400 fs-14"
                        style={{
                            backgroundColor: row.bg,
                            color: row.color,
                            border: "none",
                            whiteSpace: "pre-wrap",
                            textAlign: "center"
                        }}
                    >
                        {getWhiteLabelDictionary(value, value)}
                    </Tag>
                );
                break;
            }
            case "score": {
                colObj.title = (
                    <div style={{
                        whiteSpace: "nowrap"
                    }}
                    >
                        <Tooltip
                            placement="bottomLeft"
                            title="Hover on the chart to see the score details."
                        >
                            <InfoCircleOutlined style={{
                                cursor: "pointer",
                                color: "#A3AED0",
                                fontWeight: "bold",
                                fontSize: "14px",
                                marginRight: "2mm"
                            }}
                            />
                        </Tooltip>
                        <span>{colObj.title}</span>
                    </div>
                );
                colObj.sorter = (a, b) => a[col.key] - b[col.key];
                colObj.render = (value, {
                    score, item, mastersName, color, masterSize, share: shareVal
                }) => {
                    let min = mastersName;
                    let max = item;

                    if (shareVal < masterSize) {
                        min = item;
                        max = mastersName;
                    }
                    let hoverText = `${(score * 100).toFixed(2)}% of people engaging ${min} are also engaging ${max}`
                    if (["hcp_insights", "veterinaryinsights", "hcp_attributes", "hcp_marketscan", "insights", "patient_marketscan", "icd10", "expertmedia"].includes(marketPackage.code.replace("dev", ""))) {
                        hoverText = `${(score * 100).toFixed(2)}% of ${mastersName} are engaging with contents on ${item}.`
                    }

                    return (
                        <div className="d-flex align-items-center onHover">
                            <Tooltip
                                placement="bottomLeft"
                                title={hoverText}
                            >
                                <div style={{
                                    width: "100%",
                                    cursor: "pointer"
                                }}
                                >
                                    <TableProgress
                                        value={value}
                                        color={color}
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    );
                };
                break;
            }
            case "share":
            case "masterSize": {
                colObj.width = 120;
                colObj.sorter = (a, b) => {
                    if (col.key === "masterSize") {
                        return a[col.key] - b[col.key]
                    }
                    if (a.tiktokaudiencesize !== undefined) {
                        return a.tiktokaudiencesize - b.tiktokaudiencesize
                    } else {
                        return a[col.key] - b[col.key]
                    }
                };
                colObj.render = (value, row) => {
                    if (col.key === "masterSize") {
                        return formatNumber(value);
                    } else {
                        return formatNumber(row.tiktokaudiencesize || row.share);
                    }

                }
                break;
            }
            case "audienceIntersect": {
                colObj.width = 120;
                colObj.sorter = (a, b) => a[col.key] - b[col.key];
                colObj.render = (value) => formatNumber(value);
                break;
            }
            case "insights": {
                if (showInsights) {
                    colObj.width = 70;
                    colObj.render = (value, row) => (
                        <Button
                            className="hoverbulb"
                            type="link"
                            onClick={() => {
                                dispatch(setVisibleInsightsModal({
                                    data: { ...row, categoryName: data.discoveredCategory },
                                    trackName: "light bulb",
                                    trackKey: "advanceClickInsights",
                                    visible: true
                                }));
                            }}
                        >
                            <HiOutlineLightBulb style={{
                                fontSize: "5mm"
                            }}
                            />
                            <CrownSubscription style={{
                                fontSize: "10px", position: "absolute", top: 0
                            }}
                            />
                        </Button>
                    );
                }
                break;
            }
            default:
        }

        if (["tiktokhastags", "analysis_gdn&trv_affinity",
            "analysis_gdn&trv_purchase",
            "analysis_gdn&trv_topic"].includes(analysis?.key) && col.key === "audienceIntersect") {
            return acc
        }
        if (["facebookaudiences", "yahoodisplay", "lineaudience"].includes(marketPackage?.code?.replace("dev", ""))
            && col.key === "audienceIntersect") {
            return acc
        }
        if (showInsights && col.key === "insights") {
            acc.push(colObj)
        } else if (col.key !== "insights") {
            acc.push(colObj)
        }
        return acc;
    }, []);

    const rowSelection = {
        selectedRowKeys: selectedRow.map((t) => t.key),
        onChange: (selectedRowKeys, selectedRows) => {
            dispatch(setTileSelected({
                key: data.key,
                data: selectedRows.reduce((acc, da) => {
                    if (!da.parent) {
                        acc.push({
                            ...da,
                            discoveredCategory: data.discoveredCategory,
                            targetAudience: data.targetAudience
                        });
                    }
                    return acc;
                }, [])
            }));
        }
    };

    useEffect(() => {
        if (window.sq.oneintel.isLoadedAnalysis) return;
        if (subItems.length && !isViewer()) {
            const lastBread = subItems[subItems.length - 1];
            setSubItemsIsLoading(true);
            const lastBreadChildren = lastBread.tempChildren || lastBread.children;
            if (lastBread.showLowerLevel) {
                dispatch(setSubItemsDataPerGroup({
                    row: lastBread,
                    subData: {
                        discoveredCategory: lastBread.item,
                        children: lastBread.children,
                    }
                }));
                setTimeout(() => {
                    setSubItemsIsLoading(false);
                }, 2000)
            } else if (lastBreadChildren) {
                const childObjectList = {};
                const selectionsDetails = {};
                const selections = {};
                (lastBreadChildren).forEach((item) => {
                    const childName = item.name.toLocaleLowerCase();
                    const childList = item.children || item.tempChildren;
                    if (childList && childList.length) {
                        childObjectList[childName] = childList;
                    }
                    selections[childName] = childList ? getAllKeywordsInFolder(childList, []) : [childName];
                    selectionsDetails[childName] = {
                        ...item,
                        children: undefined,
                        tempChildren: undefined,
                    }
                });
                const notifObj = {
                    message: `${lastBread.item} Generating Report`,
                    description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
                    duration: null,
                    placement: "topRight",
                    closable: true,
                    // closeIcon: (<div />),
                    key: `${lastBread.key}_subdeepdive-item`
                };
                notification.info(notifObj);

                const getAllLastFolder = (items, tempObj) => {
                    if (!items) return tempObj
                    items.forEach((item) => {
                        const childList = item.tempChildren || item.children;
                        if (childList && childList.length) {
                            const [firstChild] = childList;
                            if (firstChild.children || firstChild.tempChildren) {
                                return getAllLastFolder(childList, tempObj)
                            } else {
                                const paths = (item.namePath || item.path).split("/")
                                const createObject = (obj, idx) => {
                                    const path = paths[idx]?.toLocaleLowerCase();
                                    if (!path) return
                                    if (!obj[path]) {
                                        if (idx === paths.length - 1) obj[path] = getAllKeywordsInFolder(childList, [])
                                        else obj[path] = {}
                                    }
                                    createObject(obj[path], idx + 1)
                                }
                                createObject(tempObj, 0)
                            }
                        }
                    })
                    return tempObj
                }

                let tempObjLastFolder = {}
                if (lastBread.namePath || lastBread.path) {
                    const lastFolder = getAllLastFolder([lastBread], {})
                    const paths = (lastBread.namePath || lastBread.path).toLocaleLowerCase().split("/").map((d) => {
                        if (d.split("~~").length > 1) return d.split("~~")[1].trim()
                        return d
                    })
                    const getObj = (idxx, obj) => {
                        const path = paths[idxx]
                        if (!path || !obj) return obj
                        return getObj(idxx + 1, obj[path])
                    }
                    let toComputeObj = getObj(0, lastFolder) || {}
                    if (isArray(toComputeObj)) toComputeObj = {}

                    if (Object.keys(toComputeObj).length) {
                        const lastObjChecker = {}
                        const lastObj = {}
                        const getAllLast = (tempObj = {}, parent) => {
                            const keys = Object.keys(tempObj);
                            if (!keys.length) return

                            keys.forEach((key) => {
                                const parentKey = parent || key
                                if (isArray(tempObj[key])) {
                                    lastObj[key] = tempObj[key]
                                    if (!lastObjChecker[parentKey]) lastObjChecker[parentKey] = []
                                    lastObjChecker[parentKey].push(key)
                                } else {
                                    getAllLast(tempObj[key], parentKey)
                                }
                            })
                        }
                        getAllLast(toComputeObj)
                        if (Object.keys(lastObj).sort().toString() !== Object.keys(selections).sort().toString()) {
                            tempObjLastFolder.lastfolders = lastObj
                            tempObjLastFolder.lastObjChecker = lastObjChecker
                        }
                    }

                    // if (Object.keys(tempObjLastFolder?.lastfolders || {}).length) {
                    //     tempObjLastFolder.lastObjChecker = selections;
                    // }
                } else {
                    console.log("No path");
                }

                const statusCallBack = (msg) => {
                    notification.info({
                        ...notifObj,
                        description: <span style={{ color: "#52c41a" }}>{msg}</span>
                    });
                };
                dispatch(setSubItemsDataPerGroup({
                    row: lastBread,
                    subData: {
                        discoveredCategory: lastBread.item,
                        children: [],
                        loadingSub: true
                    }
                }));

                const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "advanceRunDeepDive" })

                const parentPath = lastBreadChildren[0]?.parentPath?.split("/")?.reduce((acc, keyPath) => {
                    acc.push(keyPath.split("~~")[1])
                    return acc
                }, [])?.join("/");
                const categoryObj = parentPath ? { [parentPath]: selections } : undefined
                const { promise } = ReportsServices.getUsigDeepDive({ selections, masters: ReportsServices.getMasters(true), category: categoryObj, selectionsDetails, ...tempObjLastFolder }, statusCallBack, commonParams);
                promise.then((response) => {
                    if (response.length) {
                        const [itemToAdd] = response;
                        dispatch(setSubItemsDataPerGroup({
                            row: lastBread,
                            subData: {
                                discoveredCategory: lastBread.item,
                                summary: itemToAdd.summary,
                                children: (itemToAdd.children || itemToAdd.tempChildren).map((res) => {
                                    const childName = res.item.toLocaleLowerCase();
                                    const newResObj = { ...res };
                                    if (childObjectList[childName]) newResObj.tempChildren = childObjectList[childName];
                                    return newResObj;
                                })
                            }
                        }));
                    }
                    notification.destroy(`${lastBread.key}_subdeepdive-item`);
                    setSubItemsIsLoading(false);
                });
            } else {
                dispatch(setSubItemsDataPerGroup({
                    row: lastBread,
                    subData: {
                        discoveredCategory: lastBread.item,
                        children: [],
                        loadingSub: true
                    }
                }));
                const notifObj = {
                    message: `${lastBread.item} Generating Report`,
                    description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
                    duration: null,
                    placement: "topRight",
                    closable: true,
                    // closeIcon: (<div />),
                    key: `${lastBread.key}_subdeepdive-item`
                };
                notification.info(notifObj);
                const statusCallBack = (msg) => {
                    notification.info({
                        ...notifObj,
                        description: <span style={{ color: "#52c41a" }}>{msg}</span>
                    });
                };

                const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "advanceRunDeepDiveSubjects" })
                const { promise } = ReportsServices.getSubjectsDeepDive(lastBread.item, statusCallBack, commonParams);
                promise.then((response) => {
                    if (response.length) {
                        dispatch(setSubItemsDataPerGroup({
                            row: lastBread,
                            subData: {
                                discoveredCategory: lastBread.item,
                                children: response[0].children || response[0].tempChildren
                            }
                        }));
                    }
                    notification.destroy(`${lastBread.key}_subdeepdive-item`);
                    setSubItemsIsLoading(false);
                });
            }
        }
    }, [subItems.length]);

    const componentLoading = (() => {
        if (loading && data?.children?.length) {
            return false
        }
        if (data.singleLoad) {
            return (!loading || subItemsIsLoading);
        }
        return loading || subItemsIsLoading || data.loading;
    })();

    const getTileRingPercent = () => {
        const { totalSize, totalIntersect } = data.children.reduce((acc, child) => {
            acc.totalSize += Math.min(child.masterSize, (child.tiktokaudiencesize || child.share));
            acc.totalIntersect += child.audienceIntersect;
            return acc;
        }, {
            totalSize: 0,
            totalIntersect: 0
        });

        return totalIntersect / totalSize;
    };

    const getRingProgessContent = () => {
        if (componentLoading) {
            return <RingProgressSkeleton />;
        }
        if (!data.children.length) {
            return <RenderComponent isFullscreen />;
        }
        return (
            <RingProgressChart
                middleTitle={share || fRenderShare(data.children)}
                color={itemStatus.color}
                subColor={itemStatus.bg}
                percent={getTileRingPercent()}
            />
        );
    };
    const getGuageContent = () => {
        if (componentLoading) {
            return <GaugeSkeleton />;
        }
        if (!data.children.length) {
            return <RenderComponent isFullscreen />;
        }
        return (
            <>
                <GaugeChart percent={interestLevel} style={{ height: "calc(100% - 2mm)" }} titleColor={itemStatus.color} />
                <div
                    className="d-flex align-items-center gap-1 justify-content-center"
                    style={{
                        backgroundColor: itemStatus.bg,
                        padding: "1mm 4mm",
                        borderRadius: "29px",
                        height: "8mm",
                        width: "90%"
                    }}
                >

                    <span
                        className="fw-600 fs-12 d-flex align-items-center justify-content-center"
                        style={{
                            backgroundColor: itemStatus.color,
                            color: itemStatus.bg,
                            borderRadius: "50%",
                            height: "4mm",
                            width: "4mm"
                        }}
                    >
                        <ArrowUpOutlined />
                    </span>
                    <span
                        className="fw-500 fs-14"
                        style={{
                            color: itemStatus.color
                        }}
                    >
                        {itemStatus.behaviormatch}
                    </span>
                </div>
            </>
        );
    };
    return (
        <div
            ref={itemRef}
            className="report--categorydeepdive--collapse--item--content d-flex gap-1"
            style={{ width: "100%", height: "150mm" }}
        >
            <div className="d-flex-col gap-1" style={{ width: "25%" }}>
                <div className="report--panel" style={{ width: "100%", height: "50%" }}>
                    <CustomLayout
                        className="report--categorydeepdive--chartcont"
                        classNameHeader="report--categorydeepdive--chartcont--header"
                        classNameBody="d-flex align-items-center justify-content-center"
                        header={(
                            <div className="d-flex align-item-center gap-1 flex-1">
                                <div className="report--categorydeepdive--imgcont">
                                    <UsergroupAddOutlined style={{ fontSize: "6mm", color: "var(--blue-600)" }} />
                                </div>
                                <div className="d-flex-col justify-content-center">
                                    <b className="report--charttitle">
                                        Estimated Activity
                                        <Tooltip
                                            placement="bottomLeft"
                                            title="Estimated monthly topic engagement volume."
                                        >
                                            <InfoCircleOutlined style={{
                                                cursor: "pointer",
                                                color: "#A3AED0",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                marginLeft: "2mm"
                                            }}
                                            />
                                        </Tooltip>
                                    </b>
                                    <p className="report--chartsubtitle">Estimated monthly topic engagement volume</p>
                                </div>
                            </div>
                        )}
                        style={{ height: "100%" }}
                    >
                        {getRingProgessContent(share)}
                    </CustomLayout>
                </div>
                <div className="report--panel" style={{ width: "100%", height: "50%", marginTop: "0" }}>
                    <CustomLayout
                        className="report--categorydeepdive--chartcont"
                        classNameHeader="report--categorydeepdive--chartcont--header"
                        classNameBody="d-flex-col justify-content-center align-items-center"
                        header={(
                            <div className="d-flex align-item-center gap-1 flex-1">
                                <div className="report--categorydeepdive--imgcont">
                                    <HeartOutlined style={{ fontSize: "6mm", color: "var(--blue-600)" }} />
                                </div>
                                <div className="d-flex-col justify-content-center">
                                    <b className="report--charttitle">
                                        Interest Level
                                        <Tooltip
                                            placement="bottomLeft"
                                            title="Overall relevance of all discovered topics."
                                        >
                                            <InfoCircleOutlined style={{
                                                cursor: "pointer",
                                                color: "#A3AED0",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                marginLeft: "3mm"
                                            }}
                                            />
                                        </Tooltip>
                                    </b>
                                    <p className="report--chartsubtitle">Overall relevance of all discovered topics</p>
                                </div>
                            </div>
                        )}
                        style={{ height: "100%", overflow: "hidden" }}
                    >
                        {getGuageContent()}
                    </CustomLayout>
                </div>
            </div>
            <div className="report--panel" style={{ width: "75%", height: "calc(100% - 3mm)" }}>
                <div className="d-flex align-items-center gap-1">
                    <div className="d-flex align-items-center gap-1 flex-1">
                        {selectedRow.length ? (
                            <p
                                className="fw-400 fs-12 c-b-500 flex-1 d-flex align-items-center"
                                style={{
                                    height: "13mm"
                                }}
                            >
                                <span style={{
                                    padding: "1mm 2mm",
                                    background: " #EFF6FF",
                                    borderRadius: "5px",
                                    color: "#64748B"
                                }}
                                >
                                    {`${selectedRow.length} Selected`}
                                </span>
                                <Button
                                    type="link"
                                    danger
                                    size="small"
                                    onClick={() => {
                                        dispatch(removeDeepDiveItemInGroup({ groupData: data, children: selectedRow, fromSelectedTile }));
                                        setshowAlert(true);
                                        dispatch(setTileSelected({ remove: true, key: data.key }));
                                        setTimeout(() => {
                                            setshowAlert(false);
                                        }, 2000);
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "13px"
                                        }}
                                    >
                                        <CloseOutlined style={{
                                            fontSize: "11px",
                                            marginRight: "1mm"
                                        }}
                                        />
                                        Remove
                                    </div>
                                </Button>
                            </p>
                        ) : (
                            <>
                                {
                                    showAlert ? (
                                        <Alert
                                            message="Segments successfully removed"
                                            type="success"
                                            showIcon
                                            closable
                                            onClose={() => {
                                                setshowAlert(false);
                                            }}
                                            style={{ marginBottom: "2mm" }}
                                        />
                                    ) : (
                                        <p
                                            className="fw-400 fs-12 c-bg-400"
                                            style={{
                                                height: "13mm"
                                            }}
                                        >
                                            Checking the boxes on the list will exclude the segment from this category.
                                            To add more behavioral segments, hover to Actions then click “Add Behavioral Segment”.
                                        </p>
                                    )
                                }
                            </>
                        )}

                    </div>
                </div>
                {!componentLoading ? (
                    <CustomTable
                        style={{ height: "calc(100% - 13mm)" }}
                        pagination={false}
                        columns={newColumns}
                        rowSelection={rowSelection}
                        dataSource={data.children}
                        expandable={{ showExpandColumn: false }}
                        numColProps={{ width: "40px" }}
                        noCheckbox={noCheckbox}
                    />
                ) : (
                    <TableSkeleton numCols={5} noCheckBox={false} />
                )}
            </div>
        </div>
    );
}

export default CategoryDeepDiveContent;
